// @flow

import React from 'react';
import Icon, {Icons, Sizes} from '@pb/kit-component-icon';

import type {StatelessFunctionalComponent} from 'react';

/**
 * StarsRating Props
 */
type StarsRatingProps = {|
    rating: number,
|};

export const StarsRating: StatelessFunctionalComponent<StarsRatingProps> = props => (
    <>
        {new Array(props.rating).fill().map((el, i) => <Icon key={i} type={Icons.STAR_FULL} size={Sizes.Size_12}/>)}
    </>
);
